'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_SIZES = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextMask = require('react-text-mask');

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_SIZES = exports.INPUT_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  DEFAULT: 'DEFAULT'
};

var EnterpriseInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseInput, _Component);

  function EnterpriseInput(props) {
    (0, _classCallCheck3.default)(this, EnterpriseInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EnterpriseInput.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseInput)).call(this, props));

    _this.input = null;
    return _this;
  }

  (0, _createClass3.default)(EnterpriseInput, [{
    key: 'render',
    value: function render() {
      var _cx,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          size = _props.size,
          fill = _props.fill,
          mask = _props.mask,
          className = _props.className,
          width = _props.width,
          height = _props.height,
          padding = _props.padding,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'size', 'fill', 'mask', 'className', 'width', 'height', 'padding']);

      var styles = require('./EnterpriseInput.scss');

      var inputModifiers = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, styles.small, size === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles.medium, size === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles.large, size === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles['width--small'], width === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['width--medium'], width === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['width--large'], width === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles['height--small'], height === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['height--medium'], height === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['height--large'], height === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles['padding--small'], padding === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['padding--medium'], padding === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['padding--large'], padding === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles.fill, fill), _cx));

      var Tag = mask ? _reactTextMask2.default : 'input';

      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({}, restProps, {
          mask: mask,
          className: (0, _classnames2.default)(className, styles.root, inputModifiers),
          ref: function ref(component) {
            _this2.input = component;
          }
        }),
        children
      );
    }
  }]);
  return EnterpriseInput;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  type: _react.PropTypes.string,
  size: _react.PropTypes.string,
  width: _react.PropTypes.string,
  height: _react.PropTypes.string,
  padding: _react.PropTypes.string,
  fill: _react.PropTypes.bool,
  mask: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.array]),
  className: _react.PropTypes.string
}, _class.defaultProps = {
  size: INPUT_SIZES.DEFAULT,
  fill: false
}, _temp);
exports.default = EnterpriseInput;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseInput/EnterpriseInput.jsx
// module id = 1597
// module chunks = 0